import { render, staticRenderFns } from "./CanPayModal.vue?vue&type=template&id=15050456&scoped=true"
import script from "./CanPayModal.vue?vue&type=script&lang=js"
export * from "./CanPayModal.vue?vue&type=script&lang=js"
import style0 from "./CanPayModal.vue?vue&type=style&index=0&id=15050456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15050456",
  null
  
)

export default component.exports